import type { RateUnit } from '@clawhire/shared';
import { cn } from '@/lib/utils';
import { EMPTY, formatRate, formatRateWithHourly } from '@/lib/format';

export interface RateTextProps {
  rate: number | null | undefined;
  unit?: RateUnit | null;
  /** For day rates: also show the hourly equivalent (uses settings.hours_per_day, default 8). */
  showHourly?: boolean;
  hoursPerDay?: number;
  /** Extra text after the rate, e.g. "(all-in)". */
  suffix?: string;
  className?: string;
}

/** "60 EUR/h" (tabular digits, never wraps). Null renders an en dash. */
export function RateText({
  rate,
  unit = 'HOUR',
  showHourly = false,
  hoursPerDay = 8,
  suffix,
  className,
}: RateTextProps) {
  const text = showHourly ? formatRateWithHourly(rate, unit, hoursPerDay) : formatRate(rate, unit);
  return (
    <span
      className={cn('whitespace-nowrap tabular-nums', text === EMPTY && 'text-muted-foreground', className)}
    >
      {text}
      {suffix && text !== EMPTY ? ` ${suffix}` : null}
    </span>
  );
}
